import { typographyTokens } from '../../../../theme/typographyTokens';
import React, { useEffect } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import HoveredIconConfirm from '../../HoveredIconConfirmButton';
import { useDeleteEmailNotificationLocationMutation } from '../../../../services/emailNotificationLocationSlice/emailNotificationLocationSlice';
import { useGetEmailNotificationsQuery } from '../../../../services/emailNotificationsSlice/emailNotificationsSlice';
import { EmailNotificationLocation } from '../../../../../shared/types/EmailNotificationLocation';

interface EmailNotificationCardProps {
  emailNotification: EmailNotificationLocation;
  index: number;
  lastElement: number;
  setLoadingData: React.Dispatch<React.SetStateAction<boolean>>;
}

const EmailNotificationCard = ({
  emailNotification,
  index,
  lastElement,
  setLoadingData,
}: EmailNotificationCardProps) => {
  const [deleteEmailNotificationLocation, { isLoading: deletingEmailNotification }] = 
    useDeleteEmailNotificationLocationMutation();
  const { data: emailNotifications } = useGetEmailNotificationsQuery();

  useEffect(() => {
    setLoadingData(deletingEmailNotification);
  }, [deletingEmailNotification, setLoadingData]);

  const handleDelete = () => {
    if (emailNotification.id) {
      deleteEmailNotificationLocation({ id: emailNotification.id });
    }
  };

  // Find the email notification details using the emailNotificationId
  const notificationDetails = emailNotifications?.find(
    (n) => n.id === emailNotification.emailNotificationId
  );

  return (
    <>
      <Box 
        sx={{ 
          backgroundColor: '#F8F9FA', 
          boxShadow: '0.5px 0.5px 0.5px 0.5px #9c9c9c', 
          border: '0.5px solid #888888', 
          padding: '10px', 
          marginBottom: '7px' 
        }}
      >
        <Box
          my={1}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingRight: '40px',
          }}
        >
          <Box sx={{ flexGrow: 1 }}>
            <Stack display="flex">
              <Typography
                component="span"
                sx={{
                  color: '#646669',
                  font: 'normal normal normal 12px/28px Open Sans',
                }}
              >
                {notificationDetails?.notificationType || 'Email Notification'}
              </Typography>

              <Typography
                component="span"
                sx={{
                  fontSize: typographyTokens.fontSizes.body,
                  fontWeight: typographyTokens.fontWeights.medium,
                }}
              >
                {notificationDetails?.subject || 'No Subject'} 
                <b style={{ marginLeft: '10px' }}>ID: {emailNotification.emailNotificationId}</b>
              </Typography>

              {notificationDetails?.notificationNotes && (
                <Typography
                  component="span"
                  sx={{
                    color: '#646669',
                    fontSize: typographyTokens.fontSizes.caption,
                    fontStyle: 'italic',
                  }}
                >
                  {notificationDetails.notificationNotes}
                </Typography>
              )}
            </Stack>
          </Box>
            <Box sx={{ display: 'flex', gap: '24px', alignItems: 'flex-start', marginRight: '16px' }}>
            <Stack spacing={0.5}>
              <Typography
              component="span"
              sx={{
              color: '#646669',
              fontSize: typographyTokens.fontSizes.caption,
              fontWeight: typographyTokens.fontWeights.regular,
              }}
              >
              Location Type
              </Typography>
              <Typography 
              sx={{ 
              textTransform: 'capitalize', 
              fontSize: typographyTokens.fontSizes.body,
              fontWeight: typographyTokens.fontWeights.medium,
              }}
              >
              {emailNotification.locationType || 'Task'}
              </Typography>
            </Stack>
            
            <Stack spacing={0.5}>
              <Typography
              component="span"
              sx={{
              color: '#646669',
              fontSize: typographyTokens.fontSizes.caption,
              fontWeight: typographyTokens.fontWeights.regular,
              }}
              >
              Trigger Type
              </Typography>
              <Typography 
              sx={{ 
              textTransform: 'capitalize', 
              fontSize: typographyTokens.fontSizes.body,
              fontWeight: typographyTokens.fontWeights.medium,
              }}
              >
              {emailNotification.triggerType || 'N/A'}
              </Typography>
            </Stack>
            </Box>
          <Box>
            <Stack
              display="flex"
              flexDirection="row"
              justifyContent="flex-end"
              sx={{
                width: '32px',
              }}
            >
              <HoveredIconConfirm
                icon="fa-regular fa-trash"
                hoverIcon="fa-solid fa-trash"
                onClick={() => handleDelete()}
              />
            </Stack>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default EmailNotificationCard;